var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"pa-3":_vm.$vuetify.breakpoint.xsOnly}},[_c('v-layout',{attrs:{"pa-0":""}},[_c('v-flex',{staticClass:"flex-container"},[_c('chart',{attrs:{"chart":_vm.chartHourly}}),_vm._v(" "),_c('chart',{staticClass:"mt-4",attrs:{"chart":_vm.chartDaily}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40bfa594","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/report/report-index.vue
// module id = null
// module chunks = 